import {
  SUBMIT_REVIEW_SUCCESS,
  DELETE_REVIEW_SUCCESS,
  CANCEL_REVIEW_DIALOG,
  CANCEL_REMOVE_REVIEW_DIALOG,
  SUBMIT_REVIEWEXAM_SUCCESS,
  DELETE_REVIEWEXAM_SUCCESS,
} from '../actions/types'

const initialState = {
  isReview: false,
  isDelete: false,
}
const review = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_REVIEW_SUCCESS:
      return {
        ...state,
        isReview: true,
      }
    case CANCEL_REVIEW_DIALOG:
      return {
        ...state,
        isReview: false,
      }
    case DELETE_REVIEW_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    case CANCEL_REMOVE_REVIEW_DIALOG:
      return {
        ...state,
        isDelete: false,
      }
    case SUBMIT_REVIEWEXAM_SUCCESS:
      return {
        ...state,
        isReview: true,
      }
    case DELETE_REVIEWEXAM_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    default:
      return state
  }
}

export default review



// WEBPACK FOOTER //
// ./src/reducers/review.js